/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import _t from 'i18n!nls/expression-of-interest';

type Props = {
  stepNumber: number;
  totalSteps: number;
};

// #074EE8 / #EEEEEE have no matching CDS token, so the design's literal values are used.
const styles = {
  track: css`
    width: 50%;
    height: 4px;
    background: var(--cds-color-interactive-background-secondary-selected-weak);
    border-radius: 2px;
    margin: var(--cds-spacing-150) 0;
    overflow: hidden;
  `,
  fill: (percentage: number) => css`
    height: 100%;
    background: var(--cds-color-interactive-primary);
    border-radius: 2px;
    transition: width 0.2s ease-in-out;
    width: ${percentage}%;
  `,
};

const SurveyProgressIndicator = ({ stepNumber, totalSteps }: Props) => {
  const percentage = totalSteps > 0 ? Math.min(100, Math.round((stepNumber / totalSteps) * 100)) : 0;

  return (
    <div
      css={styles.track}
      role="progressbar"
      aria-label={_t('Progress')}
      aria-valuenow={percentage}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuetext={_t('Step #{stepNumber} of #{totalSteps}', { stepNumber, totalSteps })}
      data-testid="survey-progress-indicator"
    >
      <div css={styles.fill(percentage)} />
    </div>
  );
};

export default SurveyProgressIndicator;
